import React from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

import { configs } from '@hero/configs';
import { DASHBOARD_TYPES, SIDEBAR_WIDTH } from '@hero/constants';
import { OnlyDesktop, Sidebar, ThankYouAndOccasions } from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useSidebar } from '@hero/store/hooks';
import { matchPath } from '@hero/utils/historyUtils';

import { AppNavigation } from '../../molecules';

import * as S from './style';

export function DashboardLayout() {
  const location = useLocation();
  const { recognitionCode } = useParams();

  const { isSidebarOpen } = useSidebar();

  const isAuth =
    matchPath(location.pathname, ROUTE_PATHS.INVITE_DETAIL()) ||
    matchPath(location.pathname, ROUTE_PATHS.INVITE_EXPIRED()) ||
    matchPath(location.pathname, ROUTE_PATHS.SIGN_IN) ||
    matchPath(location.pathname, ROUTE_PATHS.SIGN_UP);
  const isNotFound = location.pathname === ROUTE_PATHS.NOT_FOUND;

  const collectionEditPathPattern = /^\/collections\/([^/]+)\/edit$/;

  const nonVisibleAppNavigationPaths = matchPath(
    location.pathname,
    ROUTE_PATHS.SEND_GIFT_REVIEW(recognitionCode)
  );

  const isCreationPath =
    matchPath(location.pathname, ROUTE_PATHS.NEW_RECOGNITION_GIFTS) ||
    matchPath(location.pathname, ROUTE_PATHS.NEW_RECOGNITION_RECIPIENTS) ||
    matchPath(location.pathname, ROUTE_PATHS.NEW_RECOGNITION_CONTACT_TYPE) ||
    matchPath(location.pathname, ROUTE_PATHS.NEW_RECOGNITION_EXPERIENCE) ||
    matchPath(location.pathname, ROUTE_PATHS.NEW_AUTOMATION_GIFTS) ||
    matchPath(location.pathname, ROUTE_PATHS.NEW_AUTOMATION_RULES) ||
    matchPath(location.pathname, ROUTE_PATHS.NEW_AUTOMATION_RECIPIENTS) ||
    matchPath(location.pathname, ROUTE_PATHS.NEW_AUTOMATION_EXPERIENCE) ||
    location.pathname.match(collectionEditPathPattern);

  const isDataDashboard =
    location.pathname === ROUTE_PATHS.DASHBOARD &&
    configs.dashboard?.variant === DASHBOARD_TYPES.DATA_DASHBOARD;

  function getContentX() {
    if (isCreationPath || isNotFound) {
      return 0;
    }
    return isSidebarOpen ? SIDEBAR_WIDTH.open : SIDEBAR_WIDTH.closed;
  }

  return (
    <S.DashboardLayout>
      {!isCreationPath && !nonVisibleAppNavigationPaths && <AppNavigation />}
      <S.DashboardLayoutBody
        isSidebarOpen={isSidebarOpen}
        isSidebarDisabled={isNotFound || isCreationPath}
      >
        {!isNotFound && !isCreationPath && (
          <Sidebar hasAppNavigationHeader={!nonVisibleAppNavigationPaths} />
        )}
        <S.DashboardLayoutContent
          initial="initial"
          animate="in"
          variants={{
            in: {
              x: getContentX()
            }
          }}
          transition={{
            duration: 0.5
          }}
          isDataDashboard={isDataDashboard}
        >
          <Outlet />
          {isDataDashboard && <ThankYouAndOccasions />}
        </S.DashboardLayoutContent>

        {!isAuth && <OnlyDesktop />}
      </S.DashboardLayoutBody>
    </S.DashboardLayout>
  );
}
